import PriceMaintain from './price_maintain.vue';

export default PriceMaintain;
